import { atom } from 'jotai';
import { atomWithDefault } from 'jotai/utils';
import { REVIEW_ANNOTATION_STATUS, REVIEW_MODE_PANEL_TABS } from '../constants';
import type { CompletedAnnotationT, ReviewAnnotationsT } from '../types';
export const reviewAnnotationsAtom = atom<ReviewAnnotationsT>({});
export const panelTabAtom = atom<string>(REVIEW_MODE_PANEL_TABS.PENDING);
export const completedAnnotationsAtom = atom<CompletedAnnotationT[]>([]);
export const pendingAnnotationsAtom = atom<string[]>(get => {
  const reviewAnnotations = get(reviewAnnotationsAtom);
  const completedAnnotations = get(completedAnnotationsAtom);
  return Object.keys(reviewAnnotations).filter(id => !completedAnnotations.some(annotation => annotation.annotationId === id));
});
export const reviewStatsAtom = atom<{
  approved: number;
  rejected: number;
}>(get => {
  const completedAnnotations = get(completedAnnotationsAtom);
  const approved = completedAnnotations.filter(annotation => annotation.status === REVIEW_ANNOTATION_STATUS.APPROVED).length;
  const rejected = completedAnnotations.length - approved;
  return {
    approved,
    rejected
  };
});
export const editAnnotationCallbackAtom = atom<{
  onEditCallback: (annotationId: string) => void;
  onInstanceDeleteCallback?: (annotationId: string, instanceIndex: number) => void;
} | null>(null);
export const annotationLabelsAtom = atom<string[]>(get => {
  const reviewAnnotations = get(reviewAnnotationsAtom);
  return Array.from(new Set(Object.values(reviewAnnotations).map(annotation => annotation.label)));
});
export const selectedLabelAtom = atomWithDefault(get => get(annotationLabelsAtom));
export const annotationVisibilityCallbackAtom = atom<{
  toggleAnnotationVisibilityCallback: ({
    label,
    allLabels,
    hidden
  }: {
    label?: string;
    allLabels?: boolean;
    hidden?: boolean;
  }) => void;
} | null>(null);